import { createSlice } from "@reduxjs/toolkit";

import {
  AgencyAPI,
  IInitConsortiaResponse,
  IInitMarketsResponse,
  IInitRegulatoryResponse,
} from "../services/AgencyService";

export interface AgencyState {
  account_type: "creditaccount" | "creditcard" | "both" | "";
  consortia: IInitConsortiaResponse;
  markets: IInitMarketsResponse;
  regulatory: IInitRegulatoryResponse;
  commission_level: string;
  created_by: string;
  market: string;
}

const initialState: AgencyState = {
  account_type: "",
  consortia: [],
  markets: [],
  regulatory: [],
  commission_level: "0.00",
  created_by: "",
  market: "",
};

const agencySlice = createSlice({
  name: "agency",
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addMatcher(
        AgencyAPI.endpoints.initConsortia.matchFulfilled,
        (state, action) => {
          state.consortia = action.payload;
        },
      )
      .addMatcher(
        AgencyAPI.endpoints.initMarkets.matchFulfilled,
        (state, action) => {
          state.markets = action.payload;
        },
      )
      .addMatcher(
        AgencyAPI.endpoints.initRegulatory.matchFulfilled,
        (state, action) => {
          state.regulatory = action.payload;
        },
      )
      .addMatcher(
        AgencyAPI.endpoints.getAgencyDetails.matchFulfilled,
        (state, action) => {
          state.commission_level = action.payload.commission_level;
          state.created_by = action.payload.created_by;
          state.market = action.payload.market;
          state.account_type = action.payload.account_type;
        },
      );
  },
});

export default agencySlice.reducer;
